/** Blend layer rendered by the gallery slider, outside the CTA stacking context */
export const PDP_CTL_LABEL_LAYER_ID = 'pdp-ctl-label-layer'

export type PdpEcommerceBlockCompleteTheLookCtaItem = {
  id: string
  imageUrl: string
  alt?: string
}

export type PdpEcommerceBlockCompleteTheLookCtaProps = {
  label: string
  items: PdpEcommerceBlockCompleteTheLookCtaItem[]
  /** When true, CTA shows compact (icon + label) state unless hovered/focused. */
  isCollapsed?: boolean
}
